/* /assets/ctr-giveaway.js
   Skyline GT-R giveaway elements (CNV-7117).

   - Live countdown in every [data-giveaway-countdown] (D:HH:MM:SS while more
     than a day is left, HH:MM:SS after that).
   - Hide/Show toggle on the banner. The choice is remembered for the visitor
     and applied to every banner on the page (buy box + cart drawer).
   - When the countdown reaches zero every [data-giveaway] element is hidden,
     so cached pages don't keep showing an ended giveaway.

   `data-giveaway-end` is a Unix timestamp (seconds) computed server-side in
   snippets/ctr-giveaway-end-ts.liquid, so every visitor counts down to the
   same instant regardless of their own timezone.

   Safe to load more than once.
*/
(function () {
  if (window.CtrGiveaway) {
    window.CtrGiveaway.init();
    return;
  }

  var STORAGE_KEY = 'ctrGiveawayCollapsed';
  var endSeconds = null;
  var tickId = null;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function readCollapsed() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeCollapsed(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch (e) {}
  }

  function format(totalSeconds) {
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var time = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    return days > 0 ? days + 'd ' + time : time;
  }

  function hideAll() {
    var els = document.querySelectorAll('[data-giveaway]');
    for (var i = 0; i < els.length; i++) els[i].hidden = true;
    document.documentElement.classList.add('ctr-giveaway-ended');
    document.dispatchEvent(new CustomEvent('ctr:giveaway:ended'));
  }

  function tick() {
    if (!endSeconds) return;
    var diff = Math.floor((endSeconds * 1000 - Date.now()) / 1000);

    if (diff <= 0) {
      hideAll();
      if (tickId) clearInterval(tickId);
      tickId = null;
      return;
    }

    var text = format(diff);
    var digits = document.querySelectorAll('[data-giveaway-countdown-digits]');
    for (var i = 0; i < digits.length; i++) {
      if (digits[i].textContent !== text) digits[i].textContent = text;
    }
  }

  function setCollapsed(banner, collapsed) {
    banner.classList.toggle('is-collapsed', collapsed);
    var toggle = banner.querySelector('[data-giveaway-toggle]');
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    var label = toggle.querySelector('[data-giveaway-toggle-label]');
    if (label) {
      label.textContent = toggle.getAttribute(collapsed ? 'data-label-show' : 'data-label-hide');
    }
  }

  function applyCollapsedToAll(collapsed) {
    var banners = document.querySelectorAll('[data-giveaway-banner]');
    for (var i = 0; i < banners.length; i++) setCollapsed(banners[i], collapsed);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var collapsed = readCollapsed();

    var withEnd = scope.querySelectorAll('[data-giveaway-end]');
    for (var i = 0; i < withEnd.length; i++) {
      var value = parseInt(withEnd[i].getAttribute('data-giveaway-end'), 10);
      if (value) endSeconds = value;
    }

    var banners = scope.querySelectorAll('[data-giveaway-banner]:not([data-giveaway-init])');
    for (var j = 0; j < banners.length; j++) {
      banners[j].setAttribute('data-giveaway-init', '');
      setCollapsed(banners[j], collapsed);
    }

    tick();
    if (endSeconds && !tickId) tickId = setInterval(tick, 1000);
  }

  // One delegated listener covers banners added later (cart drawer re-renders).
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-giveaway-toggle]');
    if (!toggle) return;
    var banner = toggle.closest('[data-giveaway-banner]');
    if (!banner) return;
    var collapsed = !banner.classList.contains('is-collapsed');
    writeCollapsed(collapsed);
    applyCollapsedToAll(collapsed);
  });

  // Entries = price paid x quantity, rounded down to whole dollars ($1 = 1 entry). 2X ENTRIES PROMO: count is doubled ($1 = 2 entries).
  // Each [data-giveaway-entries] holds the price of ONE unit in cents.
  function updateEntries(root, quantity) {
    var scope = root && root.querySelectorAll ? root : document;
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    var els = scope.querySelectorAll('[data-giveaway-entries]');
    for (var i = 0; i < els.length; i++) {
      var cents = parseInt(els[i].getAttribute('data-giveaway-entries-amount'), 10) || 0;
      var count = Math.floor((cents * qty) / 100) * 2;
      var countEl = els[i].querySelector('[data-giveaway-entries-count]');
      if (countEl) countEl.textContent = '+' + count;
    }
  }

  window.CtrGiveaway = { init: init, updateEntries: updateEntries };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
